class AnnouncementClose extends HTMLElement {
  constructor() {
    super();

    this.announcementBar = document.querySelector('.announcement-bar');

    this.addEventListeners();
    this.checkSessionStorage();
  }

  addEventListeners() {
    this.addEventListener("click", () => this.closeAnnouncementBar());
  }

  checkSessionStorage() {
    const shouldHide = sessionStorage.getItem("announcement-bar");

    if (!shouldHide) this.announcementBar.classList.remove('announcement-bar--disabled');
  }

  closeAnnouncementBar() {
    const calculateAnnouncementBarHeight = new Event("calculate-announcement-height");

    this.announcementBar.classList.add('announcement-bar--disabled');

    sessionStorage.setItem("announcement-bar", "true");

    // Recalculate Announcement Bar Height
    document.dispatchEvent(calculateAnnouncementBarHeight);
  }
}

customElements.define("announcement-close", AnnouncementClose);
